<template>
  <section class="sec-top-intro">
    <div class="box-top-slide">
      <div class="img-top-slide">
        <img src="@/assets/img/column/202410_01.jpg" class="only_pc" />
        <img src="@/assets/img/column/202410_01_sp.jpg" class="only_sp" />
      </div>
      <div class="img-top-slide_text">
        <h2 class="mb-0 text-left"><span>光老化対策</span><br>秋の紫外線ケアこそ<br>しっかりと！</h2>
      </div>
    </div>
  </section>

  <section class="column_content">
    <div class="feature-row mt-5 pt-5">
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202410_02.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-60">
        <h3 class="mb-3">秋の紫外線ケア、サボってない？</h3>
        <p class="mb-3">みなさんは「光老化」という言葉を、聞いたことはありますか。</p>
        <p class="mb-3">近年耳にすることが増えた、キーワードです。</p>
        <p class="mb-3">光老化とは、主に紫外線を長期間浴びることにより引き起こされる、皮膚の老化現象のこと。</p>
        <p>紫外線が強い夏が終わった秋冬であれ、もちろん一年中紫外線は降り注いでいます。</p>
      </div>
    </div>
    <div class="feature-row">
      <div class="feature-row_item_text feature-row_item_text_left w-60">
        <h3 class="mb-3">しみ、しわ、たるみ...<br>紫外線が引き起こす、光老化。</h3>
        <p class="mb-3">春から夏にかけては日焼け止めを入念に塗ったり、日傘をさしたり毎日紫外線ケアを意識的に行う方は多いでしょう。</p>
        <p class="mb-3">しかし、秋に入ると「今日は外出時間も少ないし大丈夫かな」と、紫外線ケアに対して手抜きになる時はありませんか？</p>
        <p>紫外線により引き起こされる光老化を避けるためには、夏だけでなく秋冬もしっかり紫外線ケアを行わなければいけません。</p>
      </div>
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202410_03.jpg">
      </div>
    </div>
    
    <h2 class="my-5 pt-5">やってないのはわたしだけ？<br>秋冬の紫外線ケア事情と光老化の関係とは。</h2>
    <p class="text-center mb-5 pb-5">今回は30代、40代、50代の一般女性を対象に<br>夏と比較し、どのくらいの方が紫外線ケアを継続できているのかを調査するべく<br>一般女性のみなさんに「紫外線ケアと光老化」に関してうかがいました。</p>
    <div class="feature-row">
      <div class="feature-row_item_text feature-row_item_text_left w-60">
        <h3 class="mb-3">見過ごせない光老化による肌悩み。上位は「シミ・黒ずみ・赤み」</h3>
        <p class="mb-3">まずは、今年の夏の日焼けに対する意識について聞きました。</p>
        <p class="mb-3"><strong>「今年の夏、日焼けしたと感じますか？」</strong></p>
        <p class="mb-3"><strong>『とても感じる（22.4％）』<br>『感じる（39.6％）』</strong></p>
        <p class="mb-3">約6割の方が夏の日焼けダメージを感じているようです。</p>
        <p class="mb-3"><strong>「日焼け直後の肌で気になることは何ですか？」</strong></p>
        <p class="mb-3"><strong>『シミやそばかす（51.2％）』<br>『肌が黒くなる（47.7％）』<br>『赤み（36.1％）』</strong></p>
        <p>半数近くの方が、シミやそばかす、日焼け、ついで肌の赤みといった、紫外線による美容面でのお肌ダメージを気にする方が多い傾向がみられます。</p>
      </div>
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202410_04.jpg">
      </div>
    </div>
    <div class="feature-row">
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202410_05.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-60">
        <h3 class="mb-3">夏と秋で、紫外線ケアへの意識の差が顕著に。</h3>
        <p class="mb-3">夏場は紫外線や肌へのダメージを顕著に感じる季節。そのため、一年の中でも紫外線ケアを意識する方が多いようです。</p>
        <p class="mb-3">では、夏と秋の紫外線ケアに違いはあるのでしょうか。</p>
        <p class="mb-3"><strong>「夏（6・7・8月）」と「秋（9・10・11月）」に、それぞれ紫外線ケアは何をしているかを聞いてみました。</strong></p>
        <p class="mb-3"><strong>『日焼け止めを塗る』<br>『日傘をさす』<br>『帽子やアームカバーを使用する』</strong></p>
        <p>夏も秋も上位にくる項目は同じですが、明らかに紫外線ケアを意識している方が減っているようです。</p>
      </div>
    </div>
    <div class="feature-row">
      <div class="feature-row_item_text feature-row_item_text_left w-60">
        <h3 class="mb-3">光老化は一年中意識するべし</h3>
        <p class="mb-3">夏も秋も、紫外線ケアを続ける方が多い一方で、秋は紫外線ケアへの意識が変わってしまう方が約3割いるようです。</p>
        <p class="mb-3">では、夏と秋で紫外線ケアを変える理由は何なのでしょうか？</p>
        <p class="mb-3"><strong>「夏と秋で紫外線ケアを変える理由は何ですか？」</strong></p>
        <p class="mb-3"><strong>『夏より紫外線が強くないと思うから（59.8％）』<br>『長袖を着ることが多いから（47.3％）』<br>『涼しいから（29.3％）』</strong></p>
        <p class="mb-3">秋になると、紫外線ケアが減る理由として、季節的な回答が多い結果に。</p>
        <p>しかし、太陽が出ているということは一年中紫外線が降り注いでいることには変わりありません。</p>
      </div>
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202410_06.jpg">
      </div>
    </div>
    <div class="feature-row">
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202410_07.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-60">
        <h3 class="mb-3">紫外線による肌悩みは、シミ・そばかすがトップ！</h3>
        <p class="mb-3">紫外線を浴びることは肌への刺激につながりますが、では夏を終えた現在、皆さんは今のご自身の肌に関してどんな悩みがあるのでしょうか？</p>
        <p class="mb-3"><strong>「現在感じている肌悩みについて当てはまるものを選択してください」</strong></p>
        <p class="mb-3"><strong>『顔や手の甲のシミやそばかす（44.7％）』<br>『肌のたるみ（38.0％）』<br>『肌の全体的なくすみ（30.8％）』</strong></p>
        <p class="mb-3">これらの症状は、紫外線を長時間浴びることで、肌表面だけでなく真皮の深い部分までダメージを受けてしまうことで起きる「光老化」の症状の1つといえるでしょう。</p>
        <p>しかしこの<strong>皮膚の老化現象、「光老化」について知っている方</strong>はどのくらいいるかも調査したところ、光老化に関する認識は<strong>「聞いたことがある」</strong>というレベルで、詳細を知る方は少数派のようです。</p>
      </div>
    </div>
    <div class="feature-row">
      <div class="feature-row_item_text feature-row_item_text_left w-60">
        <h3 class="mb-3">ビタミンC・Eなどの抗酸化成分が人気に</h3>
        <p class="mb-3">では<strong>「光老化対策として取り組みたいものを選んでください」</strong>と質問しました。</p>
        <p class="mb-3"><strong>『年中の紫外線ケアの徹底（42.9％）』<br>『スキンケア製品の見直し（30.1％）』</strong></p>
        <p class="mb-3">紫外線ケアに加えて、現在使っているスキンケア製品の見直しをされる方も多いようです。</p>
        <p class="mb-3">では、そのような取り組みの際に、どのような成分を取り入れたいと思うのでしょうか。</p>
        <p class="mb-3"><strong>『ビタミンC、ビタミンE、フェルラ酸などの抗酸化成分（88.5％）』<br>『ヒアルロン酸（53.1％）』<br>『レチノールやトレチノイン（44.6％）』</strong></p>
        <p>ビタミンCやビタミンE、フェルラ酸などの抗酸化成分を用いたスキンケアが人気のようです。</p>
      </div>
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202410_08.jpg">
      </div>
    </div>
    <div class="feature-row">
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202410_09.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-60">
        <h3 class="mb-3 text-center">秋冬に油断する「紫外線ケア」<br>がもたらす<br>光老化のリスク</h3>
        <p class="mb-3">今回の調査結果で、30～50代の女性の紫外線ケアや光老化の認知度などが明らかに。</p>
        <p class="mb-3">夏場は紫外線ケアや、日焼け直後の肌への保湿スキンケアを徹底している方も多いようですが、秋になるとその意識が変わる方も少なくない模様。</p>
        <p class="mb-3">夏は日傘をさす方がたくさんいる一方で、秋冬に見かけることはグッと少なくなりますよね。柔らかくなった日差しに対して、つい紫外線ケアを油断してしまう・・そんな方も多いのではないでしょうか。</p>
        <p>しかし、夏場以外にも紫外線による肌へのダメージがあるのは確か。夏に頑張った紫外線ケアの努力・・無駄にするのはもったいないです！</p>
      </div>
    </div>

    <div class="layer_01  mt-5 py-5">
      <img src="@/assets/img/column/layer-bg_01.jpg">
      <div class="layer-text">
        <p class="mb-3 fs-2">光老化に負けないために</p>
        <p class="mb-3">なめらかで透明感のある肌を手に入れたい。</p>
        <p class="mb-3">シミやそばかす、しわ、たるみの肌悩みを<br>軽減したいと思う方は多いかもしれません。</p>
        <p class="mb-3">大切なのは一年中、しっかりと紫外線ケアをすること。</p>
        <p class="mb-3">そして、スキンケアをコツコツと続けること。</p>
        <p class="mb-3">あなたが未来の自分のお肌も<br>好きでいれるように。</p>
        <p>そのお手伝いができるスキンケアアイテムを<br>マナビス化粧品は提案します。</p>
      </div>
    </div>

    <h2 class="mt-5 pt-5">光老化対策におすすめの<br>スキンケアアイテム</h2>
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/special_whiteningessence_202410.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-60">
        <h3 class="mb-3">SPECIAL<br>薬用ホワイトニングエッセンスEX</h3>
        <p class="mb-3">¥5,500</p>
        <p class="mb-3">なめらかで透明感のある肌へ。<br>しっとりとなじむ美白美容液。</p>
        <p class="mb-3">安定した状態で角層の奥まで届き、透明感美肌へ導く、ビタミンC誘導体（L-アスコルビン酸 2-グルコシド）。</p>
        <p class="mb-3">肌あれを防ぐグリチルリチン酸ジカリウム。なめらかな肌へ導く数種の保湿成分。</p>
        <p>すうっと伸びる軽いテクスチャーなのに、とても頼もしい美容液です。</p>
        <div class="mt-5">
          <router-link to="/products" class="btn">
            商品一覧へ
          </router-link>
        </div>
      </div>
    </div>

    <h2 class="my-5">特長成分</h2>
    <div class="text-center">
      <h3 class="mb-3">【L-アスコルビン酸 2-グルコシド】</h3>
      <p class="mb-3">メラニン色素の生成を抑えるとともに、<br>若々しいハリのある肌に導いてくれます。</p>
      <h3 class="mb-3 pt-3">【グリチルリチン酸ジカリウム】</h3>
      <p class="mb-3">肌荒れの炎症の悪化を防ぎ、赤みを抑える効果が期待できます。<br>敏感肌の方にもご使用いただけます。</p>
      <p>※美白：メラニンの生成を抑え、シミ・ソバカスを防ぐ。</p>
    </div>

    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_text feature-row_item_text_left w-60">
        <h3 class="mb-3">BASIC<br>薬用スキンマスク<br>チューブタイプ</h3>
        <p class="mb-3">¥5,500<br>ハーフサイズ ¥2,970</p>
        <p class="mb-3">インバスケアで保湿革命。</p>
        <p class="mb-3">洗いたての素肌を包み、<br>うるおし、なめらかにするパック。</p>
        <p>洗い流せる、やわらかなクリーム状のテクスチャーでお風呂でも使えるアイテムです。</p>
        <div class="mt-5">
          <router-link to="/products" class="btn">
            商品一覧へ
          </router-link>
        </div>
      </div>
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/basic_skinmask_tube_202410.jpg">
      </div>
    </div>

    <h2 class="my-5">特長成分</h2>
    <div class="text-center mb-5 pb-5">
      <h3 class="mb-3">美容効果の高い「グリチルリチン酸ジカリウム」と<br>肌を整える「グリコール酸」配合</h3>
      <p class="mb-3">4000年以上の歴史がある甘草（カンゾウ）から抽出・精製される「グリチルリチン酸ジカリウム」。<br class="only_pc">肌あれを防ぎ、肌を整えることに期待ができます。</p>
      <p class="mb-3">加えて、エステでも肌を整える施術に用いられる「グリコール酸」を、<br class="only_pc">毎日使っても肌に負担がかからないように絶妙なバランスで配合。</p>
      <p class="mb-3">また、20種類の植物由来成分を配合。</p>
      <h3 class="mb-3 pt-3">天然の保湿成分スクワラン</h3>
      <p class="mb-3">深海ザメから得られた成分由来の保湿成分。</p>
      <p>肌なじみが良く角層までの浸透性も高いので、肌のなめらかさとうるおいを保ちます。</p>
    </div>
   
    <div class="layer_02">
      <img src="@/assets/img/column/202410_10.jpg">
      <div class="layer-text">
        <div class="layer-text-inner">
          <h2 class="mb-3 text-left"><span>はじめての方におすすめ。</span><br>TRIAL SET</h2>
          <p class="mb-3">マナビス化粧品には、光老化にフォーカスしたときにおすすめしたいアイテムはたくさんありますし迷ってしまう方も多いかもしれません。</p>
          <p class="mb-3">そこでまずは、はじめての方に</p>
          <p class="mb-3"><strong>一度でいいから使ってみてほしい</strong></p>
          <p class="mb-3">という思いから、お手軽に始めやすい1週間のミニサイズのセットをご用意しました。</p>
          <p class="mb-3">各ラインナップからおすすめのアイテムかわいらしいミニサイズに詰め合わせました。</p>
          <p>旅行のトラベルセットとしても、ちょっとしたプレゼントにも最適。</p>
        </div>
      </div>
    </div>

    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_text feature-row_item_text_left w-60">
        <h3 class="mb-3">BASIC<br>マナビストライアルセット</h3>
        <p class="mb-3">¥2,300</p>
        <p class="mb-3"><strong>美肌の基本は洗顔にあり</strong></p>
        <p class="mb-3">マナビス化粧品の定番アイテムをギュッと詰め込みました。</p>
        <p>「スキンウォッシュ」「スキンマスク」「エモリエントローション」のミニサイズと、ウォッシュ用 泡立てネットをセットにしました。</p>
        <div class="mt-5">
          <router-link to="/products" class="btn">
            商品一覧へ
          </router-link>
        </div>
      </div>
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/basic_trialset_202410.jpg">
      </div>
    </div>
    
    <h2 class="mt-5 pt-5">その他のTRIAL SETシリーズ</h2>
    <div class="feature-row feature-row_product_list">
      <div class="feature-row_product_item">
        <router-link to="/products">
          <img src="@/assets/img/column/trial_flora_202410.jpg">
        </router-link>
        <div class="feature-row_product_detail text-center">
          <div class="feature-row_product_title mb-3">美肌菌トライアルセット</div>
          <p><strong>話題の「美肌菌」にフォーカスした注目のスキンケア</strong></p>
          <div class="feature-row_product_title">¥3,000</div>
          <p>フローラシリーズから「ファーストセラム」「スキンケアオイル」のミニサイズセット</p>
          <div class="my-5">
            <router-link to="/products" class="btn">
              商品一覧へ
            </router-link>
          </div>
        </div>
      </div>
      <div class="feature-row_product_item">
        <router-link to="/products">
          <img src="@/assets/img/column/trial_rising_202410.jpg">
        </router-link>
        <div class="feature-row_product_detail text-center">
          <div class="feature-row_product_title mb-3">モイスチャライジングセット</div>
          <p><strong>うるおいのある美肌を目指すあなたに</strong></p>
          <div class="feature-row_product_title">¥2,300</div>
          <p>ロングセラーの「エモリエントローション」「モイスチャージェル」「リンクルジェル」のミニサイズセット</p>
          <div class="my-5">
            <router-link to="/products" class="btn">
              商品一覧へ
            </router-link>
          </div>
        </div>
      </div>
      <div class="feature-row_product_item">
        <router-link to="/products">
          <img src="@/assets/img/column/trial_whitening_202410.jpg">
        </router-link>
        <div class="feature-row_product_detail text-center">
          <div class="feature-row_product_title mb-3">ホワイトニングセット</div>
          <p><strong>美白を目指す方に一度は試してほしい</strong></p>
          <div class="feature-row_product_title">¥2,150</div>
          <p>人気の「ホワイトニングエッセンス」「美白ローション」「レストアジェル」のミニサイズセット</p>
          <div class="my-5">
            <router-link to="/products" class="btn">
              商品一覧へ
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <div class="text-center mb-5 pb-5">
      <p>アンケートの詳細は以下からご覧いただけます。</p>
      <p><a href="https://prtimes.jp/main/html/rd/p/000000009.000124389.html" target="_blank" title="https://prtimes.jp/main/html/rd/p/000000009.000124389.html">【秋の紫外線ケアはさぼり気味？】約3割が夏の紫外線ケアと変えていると回答！紫外線ダメージの「光老化」の対策を訴える結果に</a></p>
    </div>

    <div class="rte">
      <font size="1">
        <p>調査概要：「紫外線ケアと光老化」に関する調査<br>
        【調査期間】2024年8月28日（水） ～ 2024年8月29日（木）<br>
        【調査方法】リンクアンドパートナーズが提供する調査PR「PRIZMA」によるインターネット調査<br>
        【調査人数】1,006人<br>
        【調査対象】調査回答時に30～50代女性と回答したモニター<br>
        【モニター提供元】ゼネラルリサーチ<br>
        ※この調査の内容は、あくまでアンケート結果の紹介であり、効果や効能を実証するものではありません。</p>
      </font>
    </div>
  </section>


  <!-- トップに戻るボタン -->
  <button id="page-top" class="btn" v-on:click="scrollTop">
    TOP
  </button>

</template>

<style scoped>
.column_content h2,.column_content h3 {
  font-weight: 500 !important;
}

.feature-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 50px;
}
.feature-row_item_image img {
  width: 100%;
}
.feature-row_item_text h3 {
  font-size: 1.25em;
}

button#page-top {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 100;
}


.layer_01 {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url('../../assets/img/column/layer-bg_01.jpg');
  background-size: cover;
  background-position: center;
  min-height: 500px; /* 最小高さを設定しておくと、極端に小さくなるのを防げます */
  padding: 20px; /* テキストと画像の端の間に余白を設定 */
}
.layer_01 img {
  display: none; /* 画像は背景として使用するので非表示にします */
}
.layer_01 .layer-text {
  padding: 10px;
  text-align: center;
  max-width: 90%; /* 文字が画像からはみ出さないように最大幅を設定 */
  word-wrap: break-word; /* 長い単語が折り返されるようにする */
  color: #424242;
  font-weight: 500;
}
.layer_01 .layer-text .fs-2 {
  font-size: 2em;
}

.feature-row_product_list {
  align-items: inherit;
}
.feature-row_product_item {
  width: 33%;
  padding: 5px;
  text-align: center;
}
.feature-row_product_detail {
  color: #333;
}
.feature-row_product_cate {
  font-size: .8em;
  color: #6b6b67;
  opacity: .65;
}

.feature-row_voice_list {
  align-items: baseline;
}
.feature-row_voice_list path.a {
  fill: none;
  stroke: #000;
  stroke-width: 2px;
}
.feature-row_voice_list .icon svg {
  width: 70px;
}
.feature-row_voice_list .feature-row_voice_item {
  width: 33%;
  padding: 5px;
  text-align: center;
}

.box-top-slide {
  position: relative;
}
.img-top-slide_text {
  position: absolute;
  bottom: 30px;
  left: 30px;
}
.img-top-slide_text h2 {
  font-size: 2em;
  font-weight: 500 !important;
}
.img-top-slide_text h2 span {
  font-size: .6em;
}

.layer_02 .layer-text {
  background-color: #cacaca;
  padding: 10px;
}
.layer_02 .layer-text .layer-text-inner {
  background-color: #fff;
  padding: 15px;
}
.layer_02 .layer-text .layer-text-inner h2 span {
  font-size: .6em;
}
@media screen and (min-width: 991px) {
    .layer_02 {
      position: relative;
      display: flex;
      align-items: center;
      background-image: url('../../assets/img/column/202410_10.jpg');
      background-size: cover;
      min-height: 500px; /* 最小高さを設定しておくと、極端に小さくなるのを防げます */
      padding: 60px; /* テキストと画像の端の間に余白を設定 */
    }
    .layer_02 img {
      display: none; /* 画像は背景として使用するので非表示にします */
    }
    .layer_02 .layer-text {
      padding: 15px;
      max-width: 45%; /* 文字が画像からはみ出さないように最大幅を設定 */
      word-wrap: break-word; /* 長い単語が折り返されるようにする */
      color: #424242;
      background-color: #fff;
    }
}
@media screen and (max-width: 699px) {
    .img-top-slide_text h2 {
      font-size: inherit;
    }
    .img-top-slide_text h2 span {
      font-size: .8em;
    }
}
@media screen and (min-width: 769px) {
   .feature-row_item_text_right {
    padding-left: 60px;
   }
   .feature-row_item_text_left {
    padding-right: 60px;
   }
   .w-40 {
    width: 40%;
   }
   .w-60 {
    width: 60%;
   }

}
@media screen and (min-width: 1px) and (max-width: 768px) {
  .column_content h2 {
    margin-bottom: 40px;
  }
  .feature-row {
    flex-direction: column;
  }
  .feature-row_item_image {
    order: 1;
    margin-bottom: 15px;
  }
  .feature-row_item_text {
    order: 2;
  }
  .feature-row_voice_item, .feature-row_product_item {
      width: 100% !important;
  }
  .w-50, .w-25, .w-75 {
    width: 100% !important;
  }
  .layer-text {
    font-size: .8em;
  }
  .layer_01 .layer-text .fs-2 {
    font-size: 1.5em;
  }
}
</style>

<script>
import $ from "jquery";

$(function() {
 var topBtn = $('#page-top');    
 topBtn.hide();
 //スクロールが500に達したらボタン表示
 $(window).scroll(function () {
 if ($(this).scrollTop() > 500) {
 topBtn.fadeIn();
        } else {
 topBtn.fadeOut();
        }
    });
    
});

// ページ内リンク
export default{
  data: () => {
    return {isActive: []}
  },
  mounted (){
    window.scroll(0, 0);
    for(let i = 0; i < 2; i++) {
      this.isActive[i] = false
    }
  },
  methods: {
    scrollToAnchorPoint(refName) {
      const el = this.$refs[refName]
      el.scrollIntoView({ behavior: 'smooth'})
    },
    openInfo(ref) {
      console.log(ref)
      this.isActive[ref] = true
      console.log(this.isActive[ref])
    },
    closeInfo(ref) {
      console.log(ref)
      this.isActive[ref] = false
      console.log(this.isActive[ref])
    },
    scrollTop(){
      window.scrollTo({
      top: 0,
      behavior: "smooth"
      })
    }
  }
}

</script>